import { allPermissions, emptyPermissions } from './permissions';

function p(patch) {
  const base = emptyPermissions();
  Object.entries(patch).forEach(([group, rights]) => {
    base[group] = { ...base[group], ...rights };
  });
  return base;
}

export const staffRoleSeed = [
  {
    roleId: 'ROLE-SUPER',
    name: 'Super Admin',
    description: 'All rights — dashboard, operations, master data, staff, and role management.',
    permissions: allPermissions(),
    active: true,
  },
  {
    roleId: 'ROLE-DASHBOARD',
    name: 'Dashboard',
    description: 'View dashboard. Select other roles separately for more access.',
    permissions: p({
      dashboard: { view: true },
    }),
    active: true,
  },
  {
    roleId: 'ROLE-KYC',
    name: 'KYC Officer',
    description: 'Verify villagers, vendors, equipment and documents.',
    permissions: p({
      villagers: { view: true, kyc: true, documents: true },
      vendors: { view: true, kyc: true, documents: true },
      equipment: { view: true, kyc: true, documents: true },
      indents: { view: true },
    }),
    active: true,
  },
  {
    roleId: 'ROLE-INDENT',
    name: 'Indent Coordinator',
    description: 'Manage indents — recommend vehicles and update deployment.',
    permissions: p({
      villagers: { view: true },
      vendors: { view: true },
      equipment: { view: true },
      indents: {
        view: true,
        edit: true,
        recommend: true,
        deployment: true,
        release: true,
      },
    }),
    active: true,
  },
  {
    roleId: 'ROLE-MASTER',
    name: 'Master Data Manager',
    description:
      'Setup catalogs only — add/edit Village names, BU names, Sites, Equipment types. Not vendors, fleet, or indents.',
    permissions: p({
      master_villages: { view: true, edit: true, delete: true },
      master_bu: { view: true, edit: true, delete: true },
      master_equipment: { view: true, edit: true, delete: true },
    }),
    active: true,
  },
  {
    roleId: 'ROLE-BU-MGR',
    name: 'BU Operations',
    description:
      'Day-to-day work in their assigned BU — vendors, fleet, and indents. Cannot change Village / BU / Site / Equipment-type catalogs.',
    permissions: p({
      vendors: { view: true, edit: true },
      equipment: { view: true, edit: true },
      indents: {
        view: true,
        edit: true,
        recommend: true,
        deployment: true,
        release: true,
      },
    }),
    active: true,
  },
  {
    roleId: 'ROLE-STAFF-MGR',
    name: 'Staff Management',
    description:
      'Manage internal users, roles, and view organisation-wide activity logs.',
    permissions: p({
      staff: {
        view: true,
        edit: true,
        delete: true,
        roles: true,
        management: true,
        activities: true,
      },
      system: { view: true, edit: true },
    }),
    active: true,
  },
];

/** Populated from listRoles() so findRoleById resolves API roles. */
let rolesCache = null;

export function setRolesCache(roles) {
  rolesCache = Array.isArray(roles) ? roles : null;
}

export function getRolesCache() {
  return rolesCache;
}

export function findRoleById(roleId) {
  const list = rolesCache?.length ? rolesCache : staffRoleSeed;
  return list.find((r) => r.roleId === roleId) || null;
}
